module.exports = __webpack_public_path__ + "static/media/Supermarket.9f3bc993.png";